module.exports = __webpack_public_path__ + "linea-music-10.a7dcedf1c8fb3ca79944.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-music-10.eot
// module id = ../../../../../src/assets/linea/fonts/linea-music-10.eot
// module chunks = styles